import styles from "../../../styles/shared/create-bot/ConfigsReview.module.css";
import { BiEdit } from "react-icons/bi";
import { riskOptions } from "../../../utility/data";
import { useSelector } from "react-redux";
import { Tooltip } from "antd";

const EditButton = ({ step, setStep }) => {
  const {
    botState: { createBotLoading },
  } = useSelector((state) => state);

  return (
    <BiEdit
      size={16}
      color={"#305cfc"}
      style={{
        marginLeft: ".5rem",
        cursor: "pointer",
        opacity: `${createBotLoading ? 0.7 : 1}`,
      }}
      onClick={() => {
        if (createBotLoading) return;
        setStep(step);
        // setIsEditing(true);
      }}
    />
  );
};

function ConfigsReview({ setStep, botConfig }) {
  return (
    <>
      {/*<h6 className={styles.title}> Confirmation</h6>*/}
      <ul className={styles.botConfigList}>
        <li>
          {/*<RxDot color={"#0C4CFC"} size={16} />*/}
          <div className={styles.configTitle}>
            <span>Bot Name:</span>{" "}
            <Tooltip
              title={botConfig.bot_name}
              color="#0d4af9"
              className={styles.tooltip}
            >
              {botConfig.bot_name}
            </Tooltip>
          </div>
          <EditButton step={1} setStep={setStep} />
        </li>
        <li>
          {/*<RxDot color={"#0C4CFC"} size={16} />*/}
          <div className={styles.configTitle}>
            <span>Selected Exchange:</span>{" "}
            {botConfig.selected_exchange === "cryptocrispy"
              ? "Demo Exchange"
              : botConfig.selected_exchange}
          </div>
          <EditButton step={1} setStep={setStep} />
        </li>
        <li>
          {/*<RxDot color={"#0C4CFC"} size={16} />*/}
          <div className={styles.configTitle}>
            <span>Risk Tolerance:</span>{" "}
            {riskOptions[botConfig.risk_tolerance - 1]}
          </div>
          <EditButton step={2} setStep={setStep} />
        </li>
        <li>
          {/*<RxDot color={"#0C4CFC"} size={16} />*/}
          <div className={styles.configTitle}>
            <span>Target Returns:</span> {botConfig.target_return_percentage}%
          </div>
          <EditButton step={2} setStep={setStep} />
        </li>
        <li>
          {/*<RxDot color={"#0C4CFC"} size={16} />*/}
          <div className={styles.configTitle}>
            <span>Crypto Allocation:</span>{" "}
            {botConfig.crypto_allocation_strategy}
          </div>
          <EditButton step={3} setStep={setStep} />
        </li>
        <li>
          {/*<RxDot color={"#0C4CFC"} size={16} />*/}
          <div className={styles.configTitle}>
            <span>CryptoCrispy Signal Source:</span> {botConfig.signal_source}
          </div>
          <EditButton step={3} setStep={setStep} />
        </li>
        <li>
          {/*<RxDot color={"#0C4CFC"} size={16} />*/}
          <div className={styles.configTitle}>
            <span>Trading Strategies:</span>{" "}
            {botConfig.selected_trading_strategies}
          </div>
          <EditButton step={4} setStep={setStep} />
        </li>
        <li>
          {/*<RxDot color={"#0C4CFC"} size={16} />*/}
          <div className={styles.configTitle}>
            <span>Number of Coins:</span> {botConfig.number_of_coins}
          </div>
          <EditButton step={4} setStep={setStep} />
        </li>
      </ul>

      {/*<p style={{ marginBottom: 0 }}>*/}
      {/*  <strong>Note:</strong> By clicking "Confirm," you agree to let Your*/}
      {/*  CryptoBot manage your crypto portfolio based on the selected preferences*/}
      {/*  and AI recommendations.*/}
      {/*</p>*/}
    </>
  );
}

export default ConfigsReview;
